import type { RouteRecordRaw } from 'vue-router';
import { ROLES } from '@AuthModule';

export default <RouteRecordRaw[]>[
  {
    path: 'animals',
    name: 'animals',
    redirect: '/shelter/animals/in-care',
    children: [
      {
        path: 'in-care',
        name: 'animals-in-care',
        component: () => import('./views/AnimalsInCare.view.vue'),
      },
      {
        path: 'all',
        name: 'all-animals',
        component: () => import('./views/AllAnimals.view.vue'),
        meta: {
          permissions: [ROLES.ALL_ANIMALS_TABLE],
        },
      },
      {
        path: 'admission/:type?/:id?/:siteId?/:buildingId?/:locationId?/:kennelId?',
        name: 'admission-form',
        component: () => import('./views/AnimalsAdmission.view.vue'),
      },
      {
        path: 'add-pet/:id',
        name: 'add-pet-form',
        component: () => import('./views/AnimalsAddPetForm.view.vue'),
      },
      {
        path: 'group-litter',
        name: 'groups-and-litters',
        component: () => import('./views/GroupLitter.view.vue'),
      },
      {
        path: '/shelter/animal/reintake/:id',
        name: 'reintake-form',
        component: () => import('./views/AnimalsAdmission.view.vue'),
      },
    ],
  },
];
